import React from 'react';
import { SignUpViewModel } from './SignUpViewModel';
import { SetupUIBindingForReactFunctionalComponent } from '../common/UIBinding';

export function SignUp(props: { viewModel: SignUpViewModel }) {
    let viewModel = props.viewModel;
    SetupUIBindingForReactFunctionalComponent(props.viewModel);

    return viewModel.showSuccessMessage ?
        <>
            <div>Congratulations, {viewModel.nickname}, you've signed up.</div>
            <br/>
            <div>Please sign in to start use TypeFast.</div>
        </>
        : <div className="form">
            <div className="field"><div className="name">Username</div><div className="value"><input type="text" value={viewModel.username} onChange={e => viewModel.username = e.target.value} /></div></div>
            <div className="field"><div className="name">Nickname</div><div className="value"><input type="text" value={viewModel.nickname} onChange={e => viewModel.nickname = e.target.value} /></div></div>
            <div className="field"><div className="name">Password</div><div className="value"><input type="password" value={viewModel.password} onChange={e => viewModel.password = e.target.value} /></div></div>
            <div className="field"><div className="name">Password Again</div><div className="value"><input type="password" value={viewModel.password2} onChange={e => viewModel.password2 = e.target.value} /></div></div>
            <div className="field"><div className="name"></div><div className="value"><button className="submit" onClick={() => viewModel.submit()}>Sign Up</button></div></div>
            <div className="field"><div className="name"></div><div className="value alert">{viewModel.error}</div></div>
        </div>;
}
